export default {"src":"/_next/static/media/twitter.dcf33da3.svg","height":60,"width":60,"blurWidth":0,"blurHeight":0};